import { render, staticRenderFns } from "./page-privacy.vue?vue&type=template&id=5d95fea1&"
import script from "./page-privacy.vue?vue&type=script&lang=js&"
export * from "./page-privacy.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports